import Template from "backbone/projects/templates/projects_count.js.hamlc"
import Inflector from 'utils/platform/inflector.js'

export default class ProjectsCountView extends Backbone.View

  initialize: ->
    @totalCount = @options.totalCount
    @collection = @options.collection
    @listenTo(@collection, "add", @render)
    @listenTo(@collection, "remove", @render)
    @listenTo(@collection, "change", @render)
    @listenTo(@collection, "render", @render)
    @listenTo(@collection, "refreshCount", @render)
    @inflector = new Inflector()

  render: (options) ->
    @totalCount = options.totalCount if options && options.totalCount != undefined
    @$el.html(Template(collection: @collection, totalCount: @totalCount, inflector: @inflector))



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/projects_count_view.js.coffee